<!-- <div  *ngIf="loaders.getLoading()"  class="d-flex justify-content-center align-items-center"> -->
<!-- <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div> -->

<!-- <div  *ngIf="loaders.getLoading()"  class="d-flex justify-content-center align-items-center">
  
    <div class="container">
    <div class="ring"></div>
    <div class="ring"></div> 
    <div class="ring"></div>
    <p>Loading...</p>
  
  </div>

</div>  -->


<div *ngIf="loaders.getLoading()" class="d-flex justify-content-center align-items-center">
    <!-- <div class="container " style="text-align: center;">
        <div class="ring"></div>
        <div class="ring"></div>
        <div class="ring"></div>
        <span class="loading">Loading...</span>
    </div> -->
    <div class="d-flex justify-content-center">
        <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-success" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-danger" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-dark" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

</div>